// Canonical location for color palette types.
// Moved here from components/user-settings/models/ so that stores/ and other
// boundary-restricted layers can import without reaching into components/.

export interface PreferredColor {
  color: string;
  value: string;
  property: string;
}

export enum PaletteType {
  Continuous = 0,
  Discrete = 1
}

export interface ColorScale {
  index: number;
  rgbColor: string;
}

export type ColorPaletteSpecialColors = {
  notApplicableColor?: string;
  otherBinColor?: string;
};

type ColorPaletteBase = {
  id: string;
  name: string;
  preferredColors?: PreferredColor[];
  thickness: number[];
  shared: boolean;
  paletteType: PaletteType;
  reverse?: boolean;
  specialColors?: ColorPaletteSpecialColors;
  colors: string[];
  colorScale?: ColorScale[];
};

export type IColorPalette = ColorPaletteBase;

export interface Palettes {
  palettes: IColorPalette[];
}

export const DEFAULT_COLOR_PALETTE_NAME = "Portland";

export const DEFAULT_FACILITY_COLOR_PALETTE_NAME = "Cold To Hot";
